module.exports = __webpack_public_path__ + "static/media/bg.28d8d412.jpg";